<div class="breadcrumbs">
  <span *ngFor="let breadcrumb of breadcrumbs; let index=index">
    <a (click)="selectBreadcrumb(breadcrumb)">
      {{breadcrumb.name | translate}}
    </a>
    <span *ngIf="breadcrumb.children.length"
          class="dropdown"
          [class.open]="breadcrumb.opened"
          (click-outside)="breadcrumb.opened = false">
      <button class="btn btn-outline"
              type="button"
              (click)="setDropDownStyle(dropdown); breadcrumb.opened = !breadcrumb.opened">
        <i aria-hidden="true" class="fa fa-light"
           [ngClass]="{
        'fa-angle-right': index !==0,
        'fa-home': index === 0
        }"></i>
      </button>
      <ul #dropdown class="dropdown-menu" style="top: 20px; left: 10px">
        <li class="dropdown-item"
            *ngFor="let child of breadcrumb.children"
            [class.highlight-child]="child?.selected">
          <a (click)="selectBreadcrumb(child); breadcrumb.opened = false"
             class="text-ellipsis">
            {{ child?.name }}
          </a>
        </li>
      </ul>
    </span>
  </span>
</div>
